import { render, staticRenderFns } from "./mark-as-endorsed.vue?vue&type=template&id=372d7803&scoped=true&"
import script from "./mark-as-endorsed.vue?vue&type=script&lang=js&"
export * from "./mark-as-endorsed.vue?vue&type=script&lang=js&"
import style0 from "./mark-as-endorsed.vue?vue&type=style&index=0&id=372d7803&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372d7803",
  null
  
)

export default component.exports